// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-container[data-v-3250400e]{min-height:100vh;padding-bottom:5rem!important}.token[data-v-3250400e]{margin-top:8rem;grid-gap:1rem;gap:1rem}.token__btn[data-v-3250400e] .v-btn__content{line-height:1.55}.token__form[data-v-3250400e]{height:100%;grid-gap:1rem;gap:1rem}.token__message[data-v-3250400e]{font-size:.75rem;line-height:1;letter-spacing:.1em}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
